interface UxSVGProps {
  classes: any;
}

export const UxDesignSVG = ({ classes }: UxSVGProps) => {
  return (
    <div className={`${classes}`}>
      <svg
        id="eQEgujtPSod1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 276 229"
        shapeRendering="geometricPrecision"
        textRendering="geometricPrecision"
      >
        <defs>
          <linearGradient
            id="eQEgujtPSod2-fill"
            x1="265.92"
            y1="161.647"
            x2="-1.36839"
            y2="56.7257"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod2-fill-0"
              offset="0%"
              stopColor="rgb(111,204,221)"
            ></stop>
            <stop
              id="eQEgujtPSod2-fill-1"
              offset="100%"
              stopColor="rgb(57,83,164)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod5-fill"
            x1="166.759"
            y1="187.25"
            x2="104.976"
            y2="27.4807"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod5-fill-0"
              offset="0%"
              stopColor="rgb(8,84,162)"
            ></stop>
            <stop
              id="eQEgujtPSod5-fill-1"
              offset="100%"
              stopColor="rgb(9,137,186)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod11-fill"
            x1="18484.5"
            y1="7143.91"
            x2="18623.4"
            y2="6941.49"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod11-fill-0"
              offset="0%"
              stopColor="rgb(101,105,176)"
            ></stop>
            <stop
              id="eQEgujtPSod11-fill-1"
              offset="100%"
              stopColor="rgb(85,172,224)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod15-fill"
            x1="169.489"
            y1="181.426"
            x2="174.058"
            y2="174.764"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod15-fill-0"
              offset="0%"
              stopColor="rgb(101,105,176)"
            ></stop>
            <stop
              id="eQEgujtPSod15-fill-1"
              offset="100%"
              stopColor="rgb(85,172,224)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod23-fill"
            x1="83125.9"
            y1="10064.8"
            x2="83122.3"
            y2="9686.81"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod23-fill-0"
              offset="0%"
              stopColor="rgb(101,105,176)"
            ></stop>
            <stop
              id="eQEgujtPSod23-fill-1"
              offset="100%"
              stopColor="rgb(85,172,224)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod34-fill"
            x1="140.747"
            y1="-5.92794"
            x2="146.677"
            y2="20.8108"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod34-fill-0"
              offset="0%"
              stopColor="rgb(71,134,198)"
            ></stop>
            <stop
              id="eQEgujtPSod34-fill-1"
              offset="100%"
              stopColor="rgb(61,194,211)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod39-fill"
            x1="56466.3"
            y1="40151.5"
            x2="46566.1"
            y2="34440.9"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod39-fill-0"
              offset="0%"
              stopColor="rgb(101,105,176)"
            ></stop>
            <stop
              id="eQEgujtPSod39-fill-1"
              offset="100%"
              stopColor="rgb(85,172,224)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod43-fill"
            x1="84.3025"
            y1="95.8936"
            x2="115.011"
            y2="106.308"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod43-fill-0"
              offset="0%"
              stopColor="rgb(5,85,164)"
            ></stop>
            <stop
              id="eQEgujtPSod43-fill-1"
              offset="56%"
              stopColor="rgb(14,111,184)"
            ></stop>
            <stop
              id="eQEgujtPSod43-fill-2"
              offset="100%"
              stopColor="rgb(6,134,166)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod44-fill"
            x1="15811.6"
            y1="9104.38"
            x2="16026.8"
            y2="11900.7"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod44-fill-0"
              offset="0%"
              stopColor="rgb(8,84,162)"
            ></stop>
            <stop
              id="eQEgujtPSod44-fill-1"
              offset="100%"
              stopColor="rgb(9,137,186)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod45-fill"
            x1="75.2989"
            y1="75.4212"
            x2="79.0916"
            y2="68.824"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod45-fill-0"
              offset="0%"
              stopColor="rgb(125,99,171)"
            ></stop>
            <stop
              id="eQEgujtPSod45-fill-1"
              offset="100%"
              stopColor="rgb(229,145,189)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod49-fill"
            x1="1540.52"
            y1="1441.31"
            x2="1560.23"
            y2="1531.78"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod49-fill-0"
              offset="0%"
              stopColor="rgb(8,84,162)"
            ></stop>
            <stop
              id="eQEgujtPSod49-fill-1"
              offset="100%"
              stopColor="rgb(9,137,186)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod52-fill"
            x1="53253.4"
            y1="34809.7"
            x2="46068.7"
            y2="30979.6"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod52-fill-0"
              offset="0%"
              stopColor="rgb(101,105,176)"
            ></stop>
            <stop
              id="eQEgujtPSod52-fill-1"
              offset="100%"
              stopColor="rgb(85,172,224)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod59-fill"
            x1="249.045"
            y1="88.2273"
            x2="249.354"
            y2="117.911"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod59-fill-0"
              offset="0%"
              stopColor="rgb(147,127,187)"
            ></stop>
            <stop
              id="eQEgujtPSod59-fill-1"
              offset="100%"
              stopColor="rgb(96,102,174)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod60-fill"
            x1="40239"
            y1="22311.6"
            x2="39425.3"
            y2="26309.5"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod60-fill-0"
              offset="0%"
              stopColor="rgb(147,127,187)"
            ></stop>
            <stop
              id="eQEgujtPSod60-fill-1"
              offset="100%"
              stopColor="rgb(96,102,174)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod61-fill"
            x1="262.119"
            y1="210.508"
            x2="258.894"
            y2="214.35"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod61-fill-0"
              offset="0%"
              stopColor="rgb(62,72,150)"
            ></stop>
            <stop
              id="eQEgujtPSod61-fill-1"
              offset="100%"
              stopColor="rgb(45,52,134)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod62-fill"
            x1="16310.7"
            y1="4861.03"
            x2="16270.4"
            y2="4891.08"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod62-fill-0"
              offset="0%"
              stopColor="rgb(62,72,150)"
            ></stop>
            <stop
              id="eQEgujtPSod62-fill-1"
              offset="100%"
              stopColor="rgb(45,52,134)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod63-fill"
            x1="59573.1"
            y1="56886.1"
            x2="56444"
            y2="58392.6"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod63-fill-0"
              offset="0%"
              stopColor="rgb(62,72,150)"
            ></stop>
            <stop
              id="eQEgujtPSod63-fill-1"
              offset="100%"
              stopColor="rgb(45,52,134)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod64-fill"
            x1="43259.2"
            y1="56414.1"
            x2="40578.1"
            y2="57560.8"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod64-fill-0"
              offset="0%"
              stopColor="rgb(62,72,150)"
            ></stop>
            <stop
              id="eQEgujtPSod64-fill-1"
              offset="100%"
              stopColor="rgb(45,52,134)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod65-fill"
            x1="42155.6"
            y1="8773.39"
            x2="42466.1"
            y2="8982.2"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod65-fill-0"
              offset="0%"
              stopColor="rgb(62,72,150)"
            ></stop>
            <stop
              id="eQEgujtPSod65-fill-1"
              offset="100%"
              stopColor="rgb(45,52,134)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod66-fill"
            x1="19236.3"
            y1="4342.97"
            x2="19300.2"
            y2="4386.62"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod66-fill-0"
              offset="0%"
              stopColor="rgb(62,72,150)"
            ></stop>
            <stop
              id="eQEgujtPSod66-fill-1"
              offset="100%"
              stopColor="rgb(45,52,134)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod67-fill"
            x1="50704.9"
            y1="60617.8"
            x2="46502.9"
            y2="63323.6"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod67-fill-0"
              offset="0%"
              stopColor="rgb(62,72,150)"
            ></stop>
            <stop
              id="eQEgujtPSod67-fill-1"
              offset="100%"
              stopColor="rgb(45,52,134)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod68-fill"
            x1="66412.9"
            y1="21437.3"
            x2="68526.8"
            y2="26752.9"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod68-fill-0"
              offset="0%"
              stopColor="rgb(147,127,187)"
            ></stop>
            <stop
              id="eQEgujtPSod68-fill-1"
              offset="100%"
              stopColor="rgb(96,102,174)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod70-fill"
            x1="196.88"
            y1="85.5632"
            x2="200.126"
            y2="93.8039"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod70-fill-0"
              offset="0%"
              stopColor="rgb(250,183,159)"
            ></stop>
            <stop
              id="eQEgujtPSod70-fill-1"
              offset="100%"
              stopColor="rgb(248,166,154)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod71-fill"
            x1="86555.3"
            y1="15747.7"
            x2="87288.9"
            y2="18432.3"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod71-fill-0"
              offset="0%"
              stopColor="rgb(147,127,187)"
            ></stop>
            <stop
              id="eQEgujtPSod71-fill-1"
              offset="100%"
              stopColor="rgb(96,102,174)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod72-fill"
            x1="63577"
            y1="9347.02"
            x2="63724.8"
            y2="10056.2"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod72-fill-0"
              offset="0%"
              stopColor="rgb(147,127,187)"
            ></stop>
            <stop
              id="eQEgujtPSod72-fill-1"
              offset="100%"
              stopColor="rgb(96,102,174)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod73-fill"
            x1="38821.8"
            y1="15015"
            x2="38439"
            y2="16853.7"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod73-fill-0"
              offset="0%"
              stopColor="rgb(147,127,187)"
            ></stop>
            <stop
              id="eQEgujtPSod73-fill-1"
              offset="100%"
              stopColor="rgb(96,102,174)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod74-fill"
            x1="18497.8"
            y1="5181.09"
            x2="18459.9"
            y2="5439.27"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod74-fill-0"
              offset="0%"
              stopColor="rgb(250,183,159)"
            ></stop>
            <stop
              id="eQEgujtPSod74-fill-1"
              offset="100%"
              stopColor="rgb(248,166,154)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod76-fill"
            x1="249.124"
            y1="78.9142"
            x2="239.608"
            y2="86.1876"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod76-fill-0"
              offset="0%"
              stopColor="rgb(37,48,105)"
            ></stop>
            <stop
              id="eQEgujtPSod76-fill-1"
              offset="100%"
              stopColor="rgb(36,9,61)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod84-fill"
            x1="60307.8"
            y1="23163.7"
            x2="63052.9"
            y2="23163.7"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod84-fill-0"
              offset="0%"
              stopColor="rgb(101,105,176)"
            ></stop>
            <stop
              id="eQEgujtPSod84-fill-1"
              offset="100%"
              stopColor="rgb(85,172,224)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod85-fill"
            x1="70205.8"
            y1="21803"
            x2="70840.5"
            y2="24846.6"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod85-fill-0"
              offset="0%"
              stopColor="rgb(71,134,198)"
            ></stop>
            <stop
              id="eQEgujtPSod85-fill-1"
              offset="100%"
              stopColor="rgb(61,194,211)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod88-fill"
            x1="59.8969"
            y1="87.0992"
            x2="58.7895"
            y2="91.2256"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod88-fill-0"
              offset="0%"
              stopColor="rgb(245,138,122)"
            ></stop>
            <stop
              id="eQEgujtPSod88-fill-1"
              offset="100%"
              stopColor="rgb(248,166,154)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod89-fill"
            x1="-10419"
            y1="7605.68"
            x2="-10594.9"
            y2="7918.03"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod89-fill-0"
              offset="0%"
              stopColor="rgb(250,183,159)"
            ></stop>
            <stop
              id="eQEgujtPSod89-fill-1"
              offset="100%"
              stopColor="rgb(248,166,154)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod91-fill"
            x1="63.074"
            y1="68.7508"
            x2="58.9239"
            y2="73.1618"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod91-fill-0"
              offset="0%"
              stopColor="rgb(90,46,105)"
            ></stop>
            <stop
              id="eQEgujtPSod91-fill-1"
              offset="100%"
              stopColor="rgb(36,9,61)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod93-fill"
            x1="52.9593"
            y1="106.239"
            x2="49.1513"
            y2="117.503"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod93-fill-0"
              offset="0%"
              stopColor="rgb(13,75,128)"
            ></stop>
            <stop
              id="eQEgujtPSod93-fill-1"
              offset="100%"
              stopColor="rgb(13,21,61)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod99-fill"
            x1="64.0034"
            y1="143.481"
            x2="27.8815"
            y2="189.334"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod99-fill-0"
              offset="0%"
              stopColor="rgb(36,94,164)"
            ></stop>
            <stop
              id="eQEgujtPSod99-fill-1"
              offset="100%"
              stopColor="rgb(32,61,116)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod100-fill"
            x1="24955.6"
            y1="56687.5"
            x2="32821.6"
            y2="61484.5"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod100-fill-0"
              offset="0%"
              stopColor="rgb(36,94,164)"
            ></stop>
            <stop
              id="eQEgujtPSod100-fill-1"
              offset="100%"
              stopColor="rgb(32,61,116)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod104-fill"
            x1="17653"
            y1="56203.3"
            x2="23822.3"
            y2="59965.6"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod104-fill-0"
              offset="0%"
              stopColor="rgb(36,94,164)"
            ></stop>
            <stop
              id="eQEgujtPSod104-fill-1"
              offset="100%"
              stopColor="rgb(32,61,116)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod105-fill"
            x1="27152.6"
            y1="28419.6"
            x2="29140.7"
            y2="32639.4"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod105-fill-0"
              offset="0%"
              stopColor="rgb(13,75,128)"
            ></stop>
            <stop
              id="eQEgujtPSod105-fill-1"
              offset="100%"
              stopColor="rgb(13,21,61)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod111-fill"
            x1="-7843.61"
            y1="9138.94"
            x2="-7964.6"
            y2="9161.09"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod111-fill-0"
              offset="0%"
              stopColor="rgb(250,183,159)"
            ></stop>
            <stop
              id="eQEgujtPSod111-fill-1"
              offset="100%"
              stopColor="rgb(248,166,154)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod112-fill"
            x1="4610.25"
            y1="7069.1"
            x2="4554.31"
            y2="7065.36"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod112-fill-0"
              offset="0%"
              stopColor="rgb(245,138,122)"
            ></stop>
            <stop
              id="eQEgujtPSod112-fill-1"
              offset="100%"
              stopColor="rgb(248,166,154)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod113-fill"
            x1="11494.8"
            y1="29291.2"
            x2="9323.32"
            y2="33900.9"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod113-fill-0"
              offset="0%"
              stopColor="rgb(13,75,128)"
            ></stop>
            <stop
              id="eQEgujtPSod113-fill-1"
              offset="100%"
              stopColor="rgb(13,21,61)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod115-fill"
            x1="43586.3"
            y1="5414.81"
            x2="43572.7"
            y2="6651.2"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod115-fill-0"
              offset="0%"
              stopColor="rgb(71,134,198)"
            ></stop>
            <stop
              id="eQEgujtPSod115-fill-1"
              offset="100%"
              stopColor="rgb(61,194,211)"
            ></stop>
          </linearGradient>
          <linearGradient
            id="eQEgujtPSod121-fill"
            x1="37861.2"
            y1="5478.02"
            x2="37847.5"
            y2="6714.18"
            spreadMethod="pad"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1 0 0 1 0 0)"
          >
            <stop
              id="eQEgujtPSod121-fill-0"
              offset="0%"
              stopColor="rgb(71,134,198)"
            ></stop>
            <stop
              id="eQEgujtPSod121-fill-1"
              offset="100%"
              stopColor="rgb(61,194,211)"
            ></stop>
          </linearGradient>
        </defs>
        <path
          id="eQEgujtPSod2"
          d="M264.172,56.7538C251.899,35.342,228.297,21.2398,205.779,25.8413C177.063,31.706,153.973,65.0227,125.23,59.3367C108.629,56.0454,96.6837,40.5014,82.848,29.819C67.2832,17.8013,47.0349,11.6012,28.9684,18.0081C10.9019,24.4151,-3.16867,45.6671,0.62065,66.2608C4.84012,89.1866,27.2506,101.903,47.915,106.759C68.5794,111.614,90.9531,112.344,108.541,125.306C120.627,134.31,129.061,148.184,132.05,163.973C134.396,176.687,133.114,190.275,137.526,202.296C153.091,244.734,201.29,228.274,226.364,209.674C253.656,189.425,268.975,160.936,274.536,124.325C278.014,101.421,275.58,76.6611,264.172,56.7538Z"
          opacity="0.4"
          fill="url(#eQEgujtPSod2-fill)"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod3"
          d="M202.288,44.4183L203.734,44.4183L203.734,47.6406L202.288,47.6406L202.288,44.4183ZM93.9227,66.8175L92.4766,66.8175L92.4766,63.6266L93.9227,63.6266L93.9227,66.8332L93.9227,66.8175ZM93.9227,58.7994L92.4766,58.7994L92.4766,55.5928L93.9227,55.5928L93.9227,58.7994ZM93.9227,50.7845L92.4766,50.7845L92.4766,47.5779L93.9227,47.5779L93.9227,50.7751L93.9227,50.7845ZM93.9227,42.7695L92.4766,42.7695L92.4766,39.5629L93.9227,39.5629L93.9227,42.7695ZM93.9227,34.7859C93.9522,33.7853,94.1016,32.7934,94.367,31.8363L92.986,31.3599C92.6839,32.4493,92.5126,33.578,92.4766,34.717L93.9227,34.7859ZM96.2716,27.89C96.8457,27.1184,97.5122,26.4372,98.2525,25.8651L97.4233,24.5486C96.5781,25.2045,95.8165,25.9836,95.1594,26.865L96.2716,27.89ZM101.931,24.1662C102.848,24.0256,103.774,23.9763,104.699,24.0189L104.699,22.4171C103.694,22.3724,102.687,22.4291,101.691,22.5864L101.931,24.1537L101.931,24.1662ZM109.04,24.0189L109.04,22.4171L111.935,22.4171L111.935,24.0189L109.04,24.0189ZM116.277,24.0189L116.277,22.4171L119.172,22.4171L119.172,24.0189L116.277,24.0189ZM123.516,24.0189L123.516,22.4171L126.408,22.4171L126.408,24.0189L123.516,24.0189ZM130.752,24.0189L130.752,22.4171L133.647,22.4171L133.647,24.0189L130.752,24.0189ZM137.988,24.0189L137.988,22.4171L140.883,22.4171L140.883,24.0189L137.988,24.0189ZM145.227,24.0189L145.227,22.4171L148.122,22.4171L148.122,24.0189L145.227,24.0189ZM152.463,24.0189L152.463,22.4171L155.358,22.4171L155.358,24.0189L152.463,24.0189ZM159.699,24.0189L159.699,22.4171L162.595,22.4171L162.595,24.0189L159.699,24.0189ZM166.939,24.0189L166.939,22.4171L169.834,22.4171L169.834,24.0189L166.939,24.0189ZM174.175,24.0189L174.175,22.4171L177.07,22.4171L177.07,24.0189L174.175,24.0189ZM181.411,24.0189L181.411,22.4171L184.306,22.4171L184.306,24.0189L181.411,24.0189ZM188.65,24.0189L188.65,22.4171L191.545,22.4171L191.545,24.0189L188.65,24.0189ZM195.595,24.5423C196.446,24.8608,197.251,25.3137,197.986,25.887L198.818,24.5768C197.972,23.9161,197.045,23.3935,196.064,23.0252L195.595,24.5423ZM200.742,29.1469C201.215,29.9994,201.586,30.916,201.846,31.874L203.233,31.4195C202.939,30.328,202.517,29.2838,201.979,28.3132L200.742,29.1469ZM202.288,36.4065L203.734,36.4065L203.734,39.6131L202.288,39.6131L202.288,36.4065Z"
          clipRule="evenodd"
          fill="rgb(44,42,41)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod4"
          d="M180.44,33.957L110.826,33.957C105.893,33.957,101.895,38.3861,101.895,43.8496L101.895,196.613C101.895,202.077,105.893,206.506,110.826,206.506L180.44,206.506C185.373,206.506,189.371,202.077,189.371,196.613L189.371,43.8496C189.371,38.3861,185.373,33.957,180.44,33.957Z"
          fill="rgb(209,229,246)"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod5"
          d="M179.76,34.9375L111.51,34.9375C106.674,34.9375,102.754,39.2795,102.754,44.6357L102.754,195.826C102.754,201.182,106.674,205.524,111.51,205.524L179.76,205.524C184.596,205.524,188.516,201.182,188.516,195.826L188.516,44.6357C188.516,39.2795,184.596,34.9375,179.76,34.9375Z"
          fill="url(#eQEgujtPSod5-fill)"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod6"
          d="M157.767,41.8281L133.5,41.8281C133.138,41.8281,132.844,42.1537,132.844,42.5553L132.844,43.8123C132.844,44.2139,133.138,44.5395,133.5,44.5395L157.767,44.5395C158.13,44.5395,158.424,44.2139,158.424,43.8123L158.424,42.5553C158.424,42.1537,158.13,41.8281,157.767,41.8281Z"
          fill="rgb(83,98,173)"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod7"
          d="M181.31,41.5117C181.61,41.5117,181.903,41.6103,182.153,41.7949C182.402,41.9795,182.596,42.2419,182.711,42.5489C182.826,42.8559,182.856,43.1937,182.798,43.5196C182.739,43.8455,182.595,44.1449,182.382,44.3798C182.17,44.6148,181.9,44.7748,181.606,44.8396C181.312,44.9045,181.007,44.8712,180.729,44.744C180.452,44.6169,180.215,44.4015,180.049,44.1252C179.882,43.8489,179.793,43.5241,179.793,43.1918C179.793,42.9711,179.832,42.7524,179.908,42.5484C179.984,42.3444,180.096,42.159,180.236,42.0029C180.377,41.8468,180.545,41.7231,180.729,41.6388C180.913,41.5545,181.111,41.5113,181.31,41.5117Z"
          clipRule="evenodd"
          fill="rgb(83,98,173)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod8"
          d="M146.419028,52.793C148.023088,52.793,149.590591,53.2686,150.924353,54.1596C152.258115,55.0506,153.297209,56.3171,153.912025,57.7988C154.525733,59.2805,154.68636,60.911,154.37286,62.4839C154.060467,64.0569,153.287239,65.5018,152.153984,66.6359C151.019622,67.7699,149.573974,68.5422,148.000932,68.8551C146.42789,69.168,144.797244,69.0074,143.31504,68.3937C141.832835,67.7799,140.566647,66.7406,139.674888,65.4071C138.784236,64.0735,138.309,62.5058,138.309,60.902C138.309,58.7516,139.164203,56.6895,140.68518,55.169C142.206156,53.6484,144.267727,52.7938,146.419028,52.793ZM146.419028,54.8931C145.230384,54.8937,144.068327,55.2466,143.080191,55.9073C142.093163,56.5679,141.323258,57.5066,140.86907,58.6046C140.413774,59.7027,140.295242,60.9107,140.527875,62.0761C140.760508,63.2415,141.333228,64.3119,142.172923,65.152C143.013725,65.992,144.084944,66.564,145.250324,66.7956C146.415705,67.0272,147.624288,66.908,148.722094,66.4531C149.8199,65.9982,150.758187,65.2281,151.418421,64.24C152.078656,63.2519,152.432036,62.0903,152.432036,60.902C152.432036,60.1125,152.276948,59.3307,151.974525,58.6013C151.672102,57.8718,151.230099,57.2091,150.670672,56.651C150.112353,56.0929,149.449903,55.6504,148.719879,55.3488C147.989854,55.0471,147.207765,54.8923,146.419028,54.8931Z"
          transform="matrix(1 0 0 1 -0.783996 0)"
          clipRule="evenodd"
          fill="rgb(255,255,255)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod9"
          d="M139.428,71.4648L151.815,71.4648C151.967,71.4792,152.108,71.5592,152.208,71.6876C152.307,71.816,152.357,71.9825,152.347,72.1513L152.347,73.3455C152.357,73.5144,152.307,73.6809,152.208,73.8092C152.108,73.9376,151.967,74.0176,151.815,74.032L139.428,74.032C139.276,74.0176,139.135,73.9376,139.036,73.8092C138.936,73.6809,138.886,73.5144,138.896,73.3455L138.896,72.1576C138.884,71.9877,138.934,71.8196,139.033,71.6899C139.133,71.5601,139.275,71.4792,139.428,71.4648Z"
          clipRule="evenodd"
          fill="rgb(255,255,255)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod10"
          d="M157.093,76.7266L134.171,76.7266C133.828,76.7266,133.551,77.0339,133.551,77.413L133.551,78.601C133.551,78.9801,133.828,79.2875,134.171,79.2875L157.093,79.2875C157.436,79.2875,157.713,78.9801,157.713,78.601L157.713,77.413C157.713,77.0339,157.436,76.7266,157.093,76.7266Z"
          opacity="0.5"
          fill="rgb(255,255,255)"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod11"
          d="M175.371,162.412C175.605,159.793,173.878,157.46,171.514,157.201C169.15,156.942,167.044,158.855,166.81,161.474C166.576,164.092,168.303,166.425,170.667,166.684C173.031,166.943,175.138,165.03,175.371,162.412Z"
          fill="url(#eQEgujtPSod11-fill)"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod12"
          d="M114.524,130.258L176.73,130.258C178.898,130.264,180.977,131.222,182.51,132.92C184.044,134.619,184.908,136.921,184.914,139.323L184.914,193.343C184.908,195.745,184.044,198.047,182.51,199.746C180.977,201.444,178.898,202.401,176.73,202.408L114.524,202.408C112.355,202.401,110.277,201.444,108.744,199.746C107.21,198.047,106.346,195.745,106.34,193.343L106.34,139.323C106.346,136.921,107.21,134.619,108.744,132.92C110.277,131.222,112.355,130.264,114.524,130.258Z"
          opacity="0.2"
          clipRule="evenodd"
          fill="rgb(255,255,255)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod13"
          d="M145.632,132.961C146.559,132.962,147.465,133.267,148.235,133.837C149.005,134.408,149.605,135.219,149.96,136.167C150.314,137.116,150.406,138.16,150.225,139.166C150.044,140.173,149.598,141.098,148.942,141.823C148.287,142.549,147.451,143.043,146.542,143.243C145.633,143.443,144.691,143.34,143.835,142.947C142.979,142.554,142.247,141.889,141.732,141.035C141.218,140.182,140.943,139.178,140.943,138.152C140.943,137.47,141.064,136.795,141.3,136.165C141.536,135.535,141.881,134.962,142.316,134.48C142.752,133.998,143.269,133.616,143.838,133.355C144.407,133.094,145.016,132.961,145.632,132.961ZM149.254,143.549C150.255,143.786,151.153,144.394,151.798,145.274C152.443,146.154,152.797,147.252,152.8,148.386L152.8,152.461L138.461,152.461L138.461,148.386C138.466,147.254,138.821,146.158,139.466,145.28C140.111,144.402,141.007,143.795,142.007,143.559C143.01,144.531,144.298,145.066,145.631,145.066C146.964,145.066,148.251,144.531,149.254,143.559L149.254,143.549Z"
          opacity="0.5"
          clipRule="evenodd"
          fill="rgb(255,255,255)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod14"
          d="M118.508,173L172.767,173C174.748,173,176.372,174.686,176.372,176.743L176.372,180.172C176.372,182.225,174.748,183.911,172.767,183.911L118.508,183.911C116.527,183.911,114.902,182.228,114.902,180.172L114.902,176.743C114.902,174.683,116.524,173,118.508,173Z"
          opacity="0.65"
          clipRule="evenodd"
          fill="rgb(255,255,255)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod15"
          d="M175.441,178.719C175.572,176.092,173.756,173.844,171.384,173.698C169.012,173.553,166.983,175.565,166.851,178.192C166.72,180.819,168.536,183.067,170.908,183.213C173.28,183.358,175.31,181.346,175.441,178.719Z"
          fill="url(#eQEgujtPSod15-fill)"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod16"
          d="M169.02,175.746L171.861,178.859L173.587,176.802L174.111,176.802L171.459,181.169L168.168,175.746L169.02,175.746Z"
          clipRule="evenodd"
          fill="rgb(255,255,255)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod17"
          d="M119.174,181.206L118.107,180.265C118.446,179.839,118.8,179.435,119.168,179.046C119.315,178.886,119.409,178.789,119.451,178.733C119.335,178.711,118.995,178.626,118.438,178.476C118.039,178.366,117.776,178.284,117.648,178.234L118.076,176.852C118.646,177.104,119.195,177.41,119.717,177.767C119.617,177.077,119.562,176.379,119.55,175.68L120.798,175.68C120.772,176.385,120.707,177.089,120.606,177.786C120.702,177.748,120.889,177.645,121.214,177.473C121.639,177.259,122.029,177.075,122.386,176.924L122.757,178.338C122.236,178.469,121.632,178.598,120.945,178.723L121.794,179.792C121.964,180.008,122.097,180.187,122.196,180.325L121.115,181.118L120.173,179.353C119.88,179.938,119.547,180.556,119.174,181.206Z"
          clipRule="evenodd"
          fill="rgb(94,156,212)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod18"
          d="M119.174,181.206L118.107,180.265C118.449,179.839,118.803,179.435,119.168,179.046C119.318,178.886,119.409,178.789,119.451,178.733C119.335,178.711,118.995,178.626,118.441,178.476C118.042,178.366,117.776,178.284,117.648,178.234L118.076,176.852C118.647,177.103,119.197,177.409,119.72,177.767C119.619,177.077,119.563,176.379,119.55,175.68L120.798,175.68C120.772,176.385,120.708,177.089,120.609,177.786C120.702,177.748,120.906,177.645,121.214,177.473C121.642,177.259,122.029,177.075,122.389,176.924L122.759,178.338C122.236,178.469,121.627,178.598,120.945,178.723L121.794,179.792C121.961,180.008,122.094,180.187,122.193,180.325L121.112,181.118L120.17,179.353C119.879,179.938,119.547,180.556,119.174,181.206Z"
          transform="matrix(1 0 0 1 7 0)"
          opacity="1"
          clipRule="evenodd"
          fill="rgb(94,156,212)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod19"
          d="M119.174,181.206L118.107,180.265C118.446,179.839,118.8,179.435,119.168,179.046C119.315,178.886,119.406,178.789,119.451,178.733C119.335,178.711,118.998,178.626,118.441,178.476C118.042,178.366,117.779,178.284,117.648,178.234L118.079,176.852C118.649,177.104,119.198,177.41,119.72,177.767C119.619,177.077,119.563,176.379,119.55,175.68L120.798,175.68C120.772,176.385,120.708,177.089,120.609,177.786C120.702,177.748,120.892,177.645,121.214,177.473C121.642,177.259,122.032,177.075,122.389,176.924L122.759,178.338C122.237,178.469,121.633,178.598,120.948,178.723L121.797,179.792C121.967,180.008,122.1,180.187,122.199,180.325L121.109,181.171L120.164,179.407C119.876,179.956,119.545,180.556,119.174,181.206Z"
          transform="matrix(1 0 0 1 14 0)"
          opacity="1"
          clipRule="evenodd"
          fill="rgb(94,156,212)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod20"
          d="M119.174,181.206L118.107,180.265C118.446,179.839,118.8,179.435,119.168,179.046C119.315,178.886,119.409,178.789,119.451,178.733C119.335,178.711,118.996,178.626,118.438,178.476C118.039,178.366,117.776,178.284,117.648,178.234L118.076,176.852C118.646,177.104,119.195,177.41,119.717,177.767C119.617,177.077,119.562,176.379,119.55,175.68L120.798,175.68C120.77,176.385,120.706,177.089,120.606,177.786C120.702,177.748,120.889,177.645,121.214,177.473C121.639,177.259,122.029,177.075,122.386,176.924L122.757,178.338C122.233,178.469,121.625,178.598,120.945,178.723L121.794,179.792C121.964,180.008,122.097,180.187,122.196,180.325L121.115,181.118L120.173,179.353C119.88,179.938,119.547,180.556,119.174,181.206Z"
          transform="matrix(1 0 0 1 21 0)"
          opacity="1"
          clipRule="evenodd"
          fill="rgb(94,156,212)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod21"
          d="M119.174,181.206L118.107,180.265C118.449,179.839,118.803,179.435,119.168,179.046C119.318,178.886,119.409,178.789,119.451,178.733C119.335,178.711,118.996,178.626,118.441,178.476C118.042,178.366,117.776,178.284,117.648,178.234L118.076,176.852C118.647,177.103,119.197,177.409,119.72,177.767C119.619,177.077,119.563,176.379,119.55,175.68L120.798,175.68C120.772,176.385,120.708,177.089,120.609,177.786C120.702,177.748,120.906,177.645,121.214,177.473C121.642,177.259,122.029,177.075,122.389,176.924L122.759,178.338C122.236,178.469,121.627,178.598,120.945,178.723L121.794,179.792C121.961,180.008,122.094,180.187,122.193,180.325L121.104,181.171L120.161,179.407C119.877,179.956,119.547,180.556,119.174,181.206Z"
          transform="matrix(1 0 0 1 28 0)"
          opacity="1"
          clipRule="evenodd"
          fill="rgb(94,156,212)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod22"
          d="M119.174,181.206L118.107,180.265C118.446,179.839,118.8,179.435,119.168,179.046C119.315,178.886,119.406,178.789,119.451,178.733C119.335,178.711,118.998,178.626,118.441,178.476C118.042,178.366,117.779,178.284,117.648,178.234L118.079,176.852C118.649,177.104,119.198,177.41,119.72,177.767C119.619,177.077,119.563,176.379,119.55,175.68L120.801,175.68C120.774,176.385,120.711,177.089,120.611,177.786C120.705,177.748,120.909,177.645,121.217,177.473C121.644,177.259,122.035,177.075,122.391,176.924L122.762,178.338C122.238,178.469,121.634,178.598,120.951,178.723L121.8,179.792C121.97,180.008,122.103,180.187,122.202,180.325L121.121,181.118L120.176,179.353C119.877,179.938,119.544,180.556,119.174,181.206Z"
          transform="matrix(1 0 0 1 35 0)"
          opacity="1"
          clipRule="evenodd"
          fill="rgb(94,156,212)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod23"
          d="M129.238,187.848L162.012,187.848C164.16,187.848,165.918,189.681,165.918,191.901L165.918,195.612C165.918,197.831,164.149,199.665,162.012,199.665L129.238,199.665C127.102,199.665,125.336,197.84,125.336,195.612L125.336,191.901C125.342,189.672,127.096,187.848,129.238,187.848Z"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod23-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod24"
          d="M118.508,156.52L172.767,156.52C174.748,156.52,176.372,158.206,176.372,160.262L176.372,163.688C176.372,165.744,174.748,167.431,172.767,167.431L118.508,167.431C116.527,167.431,114.902,165.748,114.902,163.688L114.902,160.262C114.902,158.203,116.524,156.52,118.508,156.52Z"
          opacity="0.65"
          clipRule="evenodd"
          fill="rgb(255,255,255)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod25"
          d="M169.02,159.266L171.861,162.378L173.587,160.322L174.111,160.322L171.459,164.688L168.168,159.266L169.02,159.266Z"
          clipRule="evenodd"
          fill="rgb(255,255,255)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod26"
          d="M119.174,164.725L118.107,163.8C118.446,163.374,118.8,162.969,119.168,162.581C119.315,162.421,119.409,162.324,119.451,162.267C119.335,162.245,118.995,162.161,118.438,162.01C118.039,161.9,117.776,161.819,117.648,161.769L118.076,160.386C118.646,160.638,119.195,160.944,119.717,161.302C119.617,160.61,119.561,159.911,119.55,159.211L120.798,159.211C120.772,159.918,120.708,160.622,120.606,161.32C120.702,161.28,120.889,161.179,121.214,161.007C121.639,160.791,122.029,160.609,122.386,160.458L122.757,161.872C122.236,162.004,121.632,162.132,120.945,162.258L121.794,163.327C121.964,163.543,122.097,163.721,122.196,163.856L121.115,164.652L120.173,162.888C119.88,163.471,119.547,164.083,119.174,164.725Z"
          clipRule="evenodd"
          fill="rgb(94,156,212)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod27"
          d="M119.174,164.725L118.107,163.8C118.449,163.374,118.803,162.969,119.168,162.581C119.318,162.421,119.409,162.324,119.451,162.267C119.335,162.245,118.995,162.161,118.441,162.01C118.042,161.9,117.776,161.819,117.648,161.769L118.076,160.386C118.647,160.637,119.197,160.944,119.72,161.302C119.619,160.61,119.563,159.911,119.55,159.211L120.798,159.211C120.772,159.918,120.708,160.622,120.609,161.32C120.702,161.28,120.906,161.179,121.214,161.007C121.642,160.791,122.029,160.609,122.389,160.458L122.759,161.872C122.236,162.004,121.627,162.132,120.945,162.258L121.794,163.327C121.961,163.543,122.094,163.721,122.193,163.856L121.112,164.652L120.17,162.888C119.879,163.471,119.547,164.083,119.174,164.725Z"
          transform="matrix(1 0 0 1 7 0)"
          opacity="1"
          clipRule="evenodd"
          fill="rgb(94,156,212)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod28"
          d="M119.174,164.725L118.107,163.8C118.446,163.374,118.8,162.969,119.168,162.581C119.315,162.421,119.406,162.324,119.451,162.267C119.335,162.245,118.998,162.161,118.441,162.01C118.042,161.9,117.779,161.819,117.648,161.769L118.079,160.386C118.649,160.638,119.198,160.944,119.72,161.302C119.619,160.61,119.563,159.911,119.55,159.211L120.798,159.211C120.772,159.918,120.709,160.622,120.609,161.32C120.702,161.28,120.892,161.179,121.214,161.007C121.642,160.791,122.032,160.609,122.389,160.458L122.759,161.872C122.237,162.004,121.633,162.132,120.948,162.258L121.797,163.327C121.967,163.543,122.1,163.721,122.199,163.856L121.118,164.652L120.173,162.888C119.878,163.471,119.545,164.083,119.174,164.725Z"
          transform="matrix(1 0 0 1 14 0)"
          opacity="1"
          clipRule="evenodd"
          fill="rgb(94,156,212)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod29"
          d="M119.174,164.725L118.107,163.8C118.446,163.374,118.8,162.969,119.168,162.581C119.315,162.421,119.409,162.324,119.451,162.267C119.335,162.245,118.996,162.161,118.438,162.01C118.039,161.9,117.776,161.819,117.648,161.769L118.076,160.386C118.646,160.638,119.195,160.944,119.717,161.302C119.617,160.61,119.561,159.911,119.55,159.211L120.798,159.211C120.77,159.918,120.706,160.622,120.606,161.32C120.702,161.28,120.889,161.179,121.214,161.007C121.639,160.791,122.029,160.609,122.386,160.458L122.757,161.872C122.233,162.004,121.625,162.132,120.945,162.258L121.794,163.327C121.964,163.543,122.097,163.721,122.196,163.856L121.115,164.652L120.173,162.888C119.88,163.471,119.547,164.083,119.174,164.725Z"
          transform="matrix(1 0 0 1 21 0)"
          opacity="1"
          clipRule="evenodd"
          fill="rgb(94,156,212)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod30"
          d="M119.174,164.725L118.107,163.8C118.449,163.374,118.803,162.969,119.168,162.581C119.318,162.421,119.409,162.324,119.451,162.267C119.335,162.245,118.996,162.161,118.441,162.01C118.042,161.9,117.776,161.819,117.648,161.769L118.076,160.386C118.647,160.637,119.197,160.944,119.72,161.302C119.619,160.61,119.563,159.911,119.55,159.211L120.798,159.211C120.772,159.918,120.708,160.622,120.609,161.32C120.702,161.28,120.906,161.179,121.214,161.007C121.642,160.791,122.029,160.609,122.389,160.458L122.759,161.872C122.236,162.004,121.627,162.132,120.945,162.258L121.794,163.327C121.961,163.543,122.094,163.721,122.193,163.856L121.112,164.652L120.17,162.888C119.879,163.471,119.547,164.083,119.174,164.725Z"
          transform="matrix(1 0 0 1 28 0)"
          opacity="1"
          clipRule="evenodd"
          fill="rgb(94,156,212)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod31"
          d="M119.174,164.725L118.107,163.8C118.446,163.374,118.8,162.969,119.168,162.581C119.315,162.421,119.406,162.324,119.451,162.267C119.335,162.245,118.998,162.161,118.441,162.01C118.042,161.9,117.779,161.819,117.648,161.769L118.079,160.386C118.649,160.638,119.198,160.944,119.72,161.302C119.619,160.61,119.563,159.911,119.55,159.211L120.801,159.211C120.775,159.918,120.711,160.622,120.611,161.32C120.705,161.28,120.909,161.179,121.217,161.007C121.644,160.791,122.035,160.609,122.391,160.458L122.762,161.872C122.238,162.004,121.634,162.132,120.951,162.258L121.8,163.327C121.97,163.543,122.103,163.721,122.202,163.856L121.121,164.652L120.176,162.888C119.877,163.471,119.544,164.083,119.174,164.725Z"
          transform="matrix(1 0 0 1 35 0)"
          opacity="1"
          clipRule="evenodd"
          fill="rgb(94,156,212)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod32"
          d="M140.562,100.076L140.562,117.874L134.135,117.874L134.135,100.076L128.316,100.076L137.347,84.5664L146.38,100.076L140.562,100.076Z"
          clipRule="evenodd"
          fill="rgb(255,255,255)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
          transform="matrix(1 0 0 1 0 -10)"
        ></path>
        <path
          id="eQEgujtPSod33"
          d="M150.697,103.067L150.697,85.2695L157.124,85.2695L157.124,103.067L162.945,103.067L153.912,118.577L144.879,103.067L150.697,103.067Z"
          clipRule="evenodd"
          fill="rgb(255,255,255)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
          transform="matrix(1 0 0 1 0 10)"
        ></path>
        <path
          id="eQEgujtPSod34"
          d="M156.972,11.7727C157.988,11.249,159.096,10.9773,160.217,10.9765C164.816,10.9765,168.543,15.4776,168.543,21.032C168.543,26.8089,165.003,31.0844,160.217,31.0844L131.041,31.0844C126.255,31.0844,122.715,26.8089,122.715,21.032C122.715,15.4776,126.442,10.9765,131.041,10.9765C132.162,10.9773,133.27,11.249,134.287,11.7727C134.474,8.58171,135.751,5.5894,137.858,3.40302C139.965,1.21665,142.743,0,145.63,0C148.517,0,151.296,1.21665,153.403,3.40302C155.51,5.5894,156.787,8.58171,156.974,11.7727L156.972,11.7727Z"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod34-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod35"
          d="M142.739,17.4097L142.739,27.5686L139.068,27.5686L139.068,17.4097L135.746,17.4097L140.905,8.55469L146.061,17.4097L142.739,17.4097Z"
          clipRule="evenodd"
          fill="rgb(255,255,255)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
          transform="matrix(1 0 0 1 0 -5)"
        ></path>
        <path
          id="eQEgujtPSod36"
          d="M148.522,18.7136L148.522,8.55469L152.192,8.55469L152.192,18.7136L155.514,18.7136L150.358,27.5686L145.199,18.7136L148.522,18.7136Z"
          clipRule="evenodd"
          fill="rgb(255,255,255)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
          transform="matrix(1 0 0 1 0 3)"
        ></path>
        <g id="eQEgujtPSod37" transform="matrix(1 0 0 1 0.000001 -20)">
          <path
            id="eQEgujtPSod38"
            d="M79.3227,83.293L119.225,83.293C120.592,83.293,121.461,84.5311,121.155,86.0482L113.69,122.898C113.516,123.658,113.127,124.336,112.578,124.832C112.03,125.329,111.352,125.616,110.645,125.653L70.7423,125.653C69.3726,125.653,68.5038,124.399,68.8122,122.898L76.2748,86.0482C76.4489,85.2876,76.8391,84.6092,77.388,84.1131C77.9368,83.6169,78.6151,83.3294,79.3227,83.293Z"
            clipRule="evenodd"
            fill="rgb(65,118,187)"
            fillRule="evenodd"
            stroke="none"
            strokeWidth="1"
          ></path>
          <path
            id="eQEgujtPSod39"
            style={{ mixBlendMode: "multiply" }}
            d="M115.467,129.076C114.214,130.317,112.591,130.999,110.911,130.991L101.895,130.991L101.895,58.1328L122.146,58.1328C124.391,58.1386,126.542,59.1289,128.129,60.887C129.717,62.6452,130.611,65.028,130.616,67.5144L130.616,119.695C130.611,122.181,129.717,124.564,128.129,126.322C126.542,128.08,124.391,129.07,122.146,129.076L115.467,129.076Z"
            opacity="0.5"
            clipRule="evenodd"
            fill="url(#eQEgujtPSod39-fill)"
            fillRule="evenodd"
            stroke="none"
            strokeWidth="1"
          ></path>
          <path
            id="eQEgujtPSod40"
            d="M122.09,63.4141L72.0619,63.4141C70.0472,63.4141,68.4141,65.223,68.4141,67.4544L68.4141,119.691C68.4141,121.923,70.0472,123.731,72.0619,123.731L122.09,123.731C124.105,123.731,125.738,121.923,125.738,119.691L125.738,67.4544C125.738,65.223,124.105,63.4141,122.09,63.4141Z"
            fill="rgb(255,255,255)"
            stroke="none"
            strokeWidth="1"
          ></path>
          <path
            id="eQEgujtPSod41"
            d="M98.9651,68.7852L84.371,68.7852C83.849,68.7852,83.4258,69.2539,83.4258,69.8321L83.4258,70.9135C83.4258,71.4917,83.849,71.9604,84.371,71.9604L98.9651,71.9604C99.4871,71.9604,99.9103,71.4917,99.9103,70.9135L99.9103,69.8321C99.9103,69.2539,99.4871,68.7852,98.9651,68.7852Z"
            opacity="0.3"
            fill="rgb(145,201,237)"
            stroke="none"
            strokeWidth="1"
          ></path>
          <path
            id="eQEgujtPSod42"
            d="M110.783,74.1992L84.371,74.1992C83.849,74.1992,83.4258,74.6679,83.4258,75.2462L83.4258,76.3276C83.4258,76.9058,83.849,77.3745,84.371,77.3745L110.783,77.3745C111.305,77.3745,111.728,76.9058,111.728,76.3276L111.728,75.2462C111.728,74.6679,111.305,74.1992,110.783,74.1992Z"
            opacity="0.3"
            fill="rgb(145,201,237)"
            stroke="none"
            strokeWidth="1"
          ></path>
          <path
            id="eQEgujtPSod43"
            d="M119.513,81.7852L74.6269,81.7852C72.8201,81.7852,71.3555,83.4075,71.3555,85.4087L71.3555,117.005C71.3555,119.006,72.8201,120.628,74.6269,120.628L119.513,120.628C121.32,120.628,122.784,119.006,122.784,117.005L122.784,85.4087C122.784,83.4075,121.32,81.7852,119.513,81.7852Z"
            opacity="0.2"
            fill="url(#eQEgujtPSod43-fill)"
            stroke="none"
            strokeWidth="1"
          ></path>
          <path
            id="eQEgujtPSod44"
            d="M86.0644,87.0078L100.786,108.799L109.887,100.145L120.72,118.177L73.4258,118.177L86.0644,87.0078Z"
            clipRule="evenodd"
            fill="url(#eQEgujtPSod44-fill)"
            fillRule="evenodd"
            stroke="none"
            strokeWidth="1"
          ></path>
          <path
            id="eQEgujtPSod45"
            d="M76.3007,67.6602C77.3051,67.6595,78.287,67.9889,79.1224,68.6065C79.9577,69.2242,80.6088,70.1024,80.9934,71.1301C81.3781,72.1577,81.4788,73.2886,81.283,74.3798C81.0872,75.4709,80.6036,76.4731,79.8934,77.2597C79.1833,78.0464,78.2784,78.582,77.2933,78.7989C76.3082,79.0158,75.2872,78.9041,74.3593,78.4781C73.4315,78.0521,72.6387,77.3309,72.081,76.4057C71.5234,75.4804,71.226,74.3928,71.2266,73.2803C71.2273,71.79,71.7622,70.361,72.7136,69.3072C73.665,68.2534,74.9552,67.661,76.3007,67.6602Z"
            opacity="0.3"
            clipRule="evenodd"
            fill="url(#eQEgujtPSod45-fill)"
            fillRule="evenodd"
            stroke="none"
            strokeWidth="1"
          ></path>
          <path
            id="eQEgujtPSod46"
            d="M93.8955,87.6688L106.65,87.6688C107.264,87.6881,107.851,87.9464,108.31,88.3981C108.768,88.8499,109.069,89.4662,109.158,90.1388L112.865,123.183C112.908,123.492,112.89,123.808,112.811,124.109C112.733,124.409,112.595,124.687,112.409,124.923C112.223,125.158,111.992,125.346,111.734,125.472C111.475,125.598,111.195,125.66,110.912,125.653L70.4889,125.653C69.8753,125.634,69.2873,125.376,68.8286,124.924C68.3699,124.472,68.07,123.856,67.9816,123.183L67.158,115.857L64.2743,90.1544L63.7621,85.6094C63.6946,85.126,63.7235,84.6321,63.8469,84.1625C63.9702,83.6929,64.185,83.2589,64.4761,82.891C64.7672,82.5232,65.1275,82.2305,65.5317,82.0335C65.9359,81.8365,66.3741,81.74,66.8156,81.7508L83.6567,81.7508C85.5726,81.7508,86.5263,82.5219,87.7743,84.2992C89.9053,87.3146,90.3411,87.6688,93.8955,87.6688Z"
            clipRule="evenodd"
            fill="rgb(247,199,81)"
            fillRule="evenodd"
            stroke="none"
            strokeWidth="1"
          ></path>
          <path
            id="eQEgujtPSod47"
            d="M102.48,94.2235C104.279,94.2235,105.737,92.6082,105.737,90.6156C105.737,88.6231,104.279,87.0078,102.48,87.0078C100.681,87.0078,99.2227,88.6231,99.2227,90.6156C99.2227,92.6082,100.681,94.2235,102.48,94.2235Z"
            fill="rgb(254,199,113)"
            stroke="none"
            strokeWidth="1"
          ></path>
          <path
            id="eQEgujtPSod48"
            d="M76.3205,67.6602C77.3286,67.6602,78.314,67.9915,79.152,68.6121C79.99,69.2328,80.6429,70.1149,81.028,71.1468C81.4131,72.1786,81.5132,73.3139,81.3155,74.4088C81.1178,75.5037,80.6312,76.509,79.9174,77.2974C79.2036,78.0858,78.2946,78.622,77.3056,78.8379C76.3165,79.0538,75.2918,78.9398,74.3613,78.5104C73.4308,78.081,72.6362,77.3553,72.0782,76.4254C71.5201,75.4955,71.2238,74.4032,71.2266,73.2866C71.2303,71.7929,71.7686,70.3619,72.7235,69.3072C73.6784,68.2524,74.972,67.6602,76.3205,67.6602Z"
            opacity="0.3"
            clipRule="evenodd"
            fill="rgb(145,201,237)"
            fillRule="evenodd"
            stroke="none"
            strokeWidth="1"
          ></path>
          <path
            id="eQEgujtPSod49"
            d="M76.5061,76.5387C78.0175,76.5387,79.2427,75.1817,79.2427,73.5076C79.2427,71.8336,78.0175,70.4766,76.5061,70.4766C74.9947,70.4766,73.7695,71.8336,73.7695,73.5076C73.7695,75.1817,74.9947,76.5387,76.5061,76.5387Z"
            fill="url(#eQEgujtPSod49-fill)"
            stroke="none"
            strokeWidth="1"
          ></path>
        </g>
        <g id="eQEgujtPSod50" transform="matrix(1 0 0 1 0 30.000001)">
          <path
            id="eQEgujtPSod51"
            d="M189.518,52.1914L233.337,52.1914C234.837,52.1914,235.791,53.5518,235.454,55.2131L227.247,95.6734C226.91,97.3378,225.408,98.6982,223.905,98.6982L180.086,98.6982C178.583,98.6982,177.629,97.3378,177.966,95.6734L186.173,55.2131C186.498,53.5518,188.004,52.1914,189.518,52.1914Z"
            clipRule="evenodd"
            fill="rgb(0,86,161)"
            fillRule="evenodd"
            stroke="none"
            strokeWidth="1"
          ></path>
          <path
            id="eQEgujtPSod52"
            style={{ mixBlendMode: "multiply" }}
            d="M189.368,101.42L176.146,101.42C174.453,101.403,172.823,100.71,171.554,99.4679C170.286,98.2256,169.466,96.5177,169.244,94.6585L165.687,62.9467C165.546,61.7878,165.632,60.609,165.938,59.4899C166.244,58.3709,166.763,57.3376,167.461,56.4598C168.158,55.5821,169.018,54.8804,169.981,54.4021C170.944,53.9238,171.989,53.6801,173.045,53.6873L173.384,53.6873L173.384,46.036C173.392,43.304,174.376,40.6866,176.121,38.7551C177.865,36.8235,180.228,35.7348,182.695,35.7266L185.553,35.7266C186.348,36.2751,189.427,38.72,189.379,44.4844L189.368,101.42Z"
            opacity="0.5"
            clipRule="evenodd"
            fill="url(#eQEgujtPSod52-fill)"
            fillRule="evenodd"
            stroke="none"
            strokeWidth="1"
          ></path>
          <path
            id="eQEgujtPSod53"
            d="M224.302,41.5195L182.311,41.5195C179.734,41.5195,177.645,43.8337,177.645,46.6883L177.645,92.3582C177.645,95.2129,179.734,97.527,182.311,97.527L224.302,97.527C226.879,97.527,228.969,95.2129,228.969,92.3582L228.969,46.6883C228.969,43.8337,226.879,41.5195,224.302,41.5195Z"
            fill="rgb(242,243,250)"
            stroke="none"
            strokeWidth="1"
          ></path>
          <path
            id="eQEgujtPSod54"
            d="M224.843,46.4492L181.783,46.4492C181.133,46.4492,180.605,47.033,180.605,47.7532L180.605,50.6589C180.605,51.379,181.133,51.9628,181.783,51.9628L224.843,51.9628C225.494,51.9628,226.021,51.379,226.021,50.6589L226.021,47.7532C226.021,47.033,225.494,46.4492,224.843,46.4492Z"
            fill="rgb(220,232,246)"
            stroke="none"
            strokeWidth="1"
          ></path>
          <path
            id="eQEgujtPSod55"
            d="M225.231,58.2617L181.395,58.2617C180.959,58.2617,180.605,58.6533,180.605,59.1363L180.605,61.0922C180.605,61.5752,180.959,61.9667,181.395,61.9667L225.231,61.9667C225.667,61.9667,226.021,61.5752,226.021,61.0922L226.021,59.1363C226.021,58.6533,225.667,58.2617,225.231,58.2617Z"
            fill="rgb(220,232,246)"
            stroke="none"
            strokeWidth="1"
          ></path>
          <path
            id="eQEgujtPSod56"
            d="M225.231,67.8008L181.395,67.8008C180.959,67.8008,180.605,68.1923,180.605,68.6753L180.605,70.6312C180.605,71.1142,180.959,71.5058,181.395,71.5058L225.231,71.5058C225.667,71.5058,226.021,71.1142,226.021,70.6312L226.021,68.6753C226.021,68.1923,225.667,67.8008,225.231,67.8008Z"
            fill="rgb(220,232,246)"
            stroke="none"
            strokeWidth="1"
          ></path>
          <path
            id="eQEgujtPSod57"
            d="M225.231,77.332L181.395,77.332C180.959,77.332,180.605,77.7236,180.605,78.2066L180.605,80.1625C180.605,80.6455,180.959,81.037,181.395,81.037L225.231,81.037C225.667,81.037,226.021,80.6455,226.021,80.1625L226.021,78.2066C226.021,77.7236,225.667,77.332,225.231,77.332Z"
            fill="rgb(220,232,246)"
            stroke="none"
            strokeWidth="1"
          ></path>
          <path
            id="eQEgujtPSod58"
            d="M205.498,56.998L219.512,56.998C220.186,57.0183,220.832,57.3014,221.336,57.7974C221.839,58.2935,222.169,58.9706,222.266,59.7094L226.336,95.9851C226.384,96.3245,226.364,96.6716,226.278,97.0017C226.191,97.3318,226.041,97.6369,225.837,97.8954C225.632,98.154,225.379,98.3598,225.095,98.4982C224.811,98.6366,224.503,98.7043,224.193,98.6964L179.8,98.6964C179.126,98.6762,178.48,98.3931,177.976,97.897C177.473,97.401,177.143,96.7239,177.046,95.9851L176.143,87.9419L172.977,59.7094L172.411,54.7192C172.336,54.1885,172.367,53.6462,172.502,53.1304C172.638,52.6146,172.873,52.1379,173.193,51.7338C173.512,51.3298,173.908,51.0083,174.351,50.7919C174.795,50.5755,175.276,50.4695,175.761,50.4814L194.249,50.4814C196.355,50.4814,197.402,51.3277,198.777,53.2773C201.118,56.6093,201.596,56.998,205.498,56.998Z"
            clipRule="evenodd"
            fill="rgb(247,199,81)"
            fillRule="evenodd"
            stroke="none"
            strokeWidth="1"
          ></path>
        </g>
        <path
          id="eQEgujtPSod59"
          d="M250.313,83.5067C256.191,96.1921,259.004,104.157,257.031,111.614C255.429,117.66,248.937,120.745,242.032,121.478L240.844,117.403C248.867,102.781,251.08,106.389,242.078,90.4967C240.507,87.6756,241.079,83.8233,243.354,81.8925C245.629,79.9616,248.748,80.6794,250.321,83.4973L250.313,83.5067ZM241.987,116.971L241.97,116.914C241.874,116.913,241.779,116.926,241.687,116.955C241.785,116.984,241.887,116.989,241.987,116.971Z"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod59-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod60"
          style={{ mixBlendMode: "multiply" }}
          d="M250.313,83.5067C254.193,91.8822,256.737,98.1982,257.45,103.671C255.22,106.639,253.304,107.432,250.525,108.235C250.624,110.279,251.091,114.162,251.029,116.209C255.036,114.714,255.947,113.037,257.031,111.614C255.432,117.66,248.937,120.745,242.032,121.478L240.844,117.403C248.867,102.781,251.08,106.389,242.078,90.4967C240.507,87.6756,241.079,83.8233,243.354,81.8925C245.629,79.9616,248.748,80.6794,250.321,83.4973L250.313,83.5067ZM241.987,116.971L241.97,116.914C241.874,116.913,241.779,116.926,241.687,116.955C241.785,116.985,241.887,116.991,241.987,116.971Z"
          opacity="0.5"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod60-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod61"
          d="M256.706,207.023C257.536,209.617,257.982,212.342,258.025,215.094C258.025,216.295,257.807,217.179,256.587,217.376C256.1,217.458,255.67,217.69,255.548,217.931C255.243,218.536,255.681,219.686,256.743,219.812C258.905,220.081,262.799,219.812,264.426,219.567C266.124,219.32,264.78,217.721,264.092,213.53C263.933,212.59,263.809,211.715,264.092,211.12C264.618,209.954,264.624,208.825,263.86,207.289C263.229,206.035,262.25,205.515,261.217,204.468C259.052,202.327,255.919,204.594,256.706,207.023Z"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod61-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod62"
          style={{ mixBlendMode: "multiply" }}
          d="M256.702,207.02C256.905,207.6,257.073,208.195,257.206,208.8C259.122,209.631,262.866,207.907,263.129,206.252C262.563,205.641,261.901,205.18,261.205,204.484C259.048,202.324,255.915,204.591,256.702,207.02Z"
          opacity="0.5"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod62-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod63"
          d="M250.116,122.461C252.77,126.082,254.592,130.361,255.425,134.933C256.378,139.472,257.035,144.081,257.389,148.725C258.847,167.184,261.263,186.283,263.004,204.422C262.789,206.015,257.038,207.908,255.872,206.93C250.413,186.718,244.552,165.645,240.307,144.964C238.776,137.532,238.757,132.758,238.839,123.414L246.293,122.68L250.116,122.461Z"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod63-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod64"
          style={{ mixBlendMode: "multiply" }}
          d="M255.853,206.934C250.397,186.722,244.558,165.671,240.288,144.989C238.757,137.557,238.737,132.783,238.819,123.44L242.937,123.035C247.901,129.339,249.132,132.357,248.752,143.864C248.373,155.371,248.965,158.496,251.093,169.495C252.989,179.554,255.338,196.452,256.441,207.219C256.226,207.181,256.024,207.083,255.853,206.934Z"
          opacity="0.5"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod64-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod65"
          d="M240.212,212.456C240.716,213.738,241.395,214.81,241.593,215.85C242.035,218.157,241.104,220.474,238.811,220.496L223.812,220.655C224.095,215.038,231.417,217.471,234.201,212.587C235.302,210.663,239.462,210.556,240.212,212.456Z"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod65-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod66"
          style={{ mixBlendMode: "multiply" }}
          d="M240.214,212.456C240.464,213.082,240.755,213.672,241.013,214.223C240.178,216.59,234.099,215.929,232.973,214.104C233.459,213.68,233.876,213.167,234.206,212.587C235.305,210.663,239.465,210.556,240.214,212.456Z"
          opacity="0.5"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod66-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod67"
          d="M227.334,122.418C227.249,127.358,225.871,133.953,226.182,140.736C227.295,164.994,231.231,188.127,233.438,212.401C233.586,213.949,239.766,214.397,240.748,212.172C241.693,190.964,240.81,165.605,243.694,145.093C248.666,138.282,248.256,131.909,243.785,122.681L233.665,121.594L227.334,122.418Z"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod67-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod68"
          d="M225.13,97.8639C226.74,109.499,225.557,115.38,226.85,126.354C233.871,131.591,247.096,125.175,253.081,125.858C248.214,119.022,249.136,110.621,249.835,102.697C251.009,89.3757,250.591,82.3011,236.52,83.5768C227.719,84.3699,224.077,90.2721,225.13,97.8639Z"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod68-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <g
          id="eQEgujtPSod69"
          transform="matrix(0.930401 -0.366542 0.366542 0.930401 -17.810364 90.33451)"
        >
          <path
            id="eQEgujtPSod70"
            d="M203.952,93.9418C202.508,92.4027,202.008,92.2084,201.226,90.1804C200.516,88.3247,199.245,87.3593,197.975,86.3155C196.704,85.2717,196.183,84.1966,195.094,83.0399C193.648,81.504,193.133,82.924,194.143,84.4599L195.923,87.165C194.865,89.8763,193.625,89.9641,194.508,91.6598C195.18,92.8214,196.065,93.8135,197.106,94.5718C199.163,95.8883,198.586,94.2301,201.385,97.1139C202.958,95.904,203.077,95.8131,203.952,93.9418Z"
            clipRule="evenodd"
            fill="url(#eQEgujtPSod70-fill)"
            fillRule="evenodd"
            stroke="none"
            strokeWidth="1"
          ></path>
          <path
            id="eQEgujtPSod71"
            d="M231.757,100.326C228.624,107.946,223.021,112.604,218.764,113.322C210.863,114.651,204.38,101.934,199.676,96.3266C199.11,94.402,201.329,91.3114,202.936,92.1076C206.68,96.919,212.988,102.571,216.175,102.248C219.361,101.925,220.491,99.0662,221.504,96.4834C226.569,83.5409,229.595,84.171,236.166,82.4062C238.965,84.0487,234.411,93.866,231.757,100.326Z"
            clipRule="evenodd"
            fill="url(#eQEgujtPSod71-fill)"
            fillRule="evenodd"
            stroke="none"
            strokeWidth="1"
          ></path>
          <path
            id="eQEgujtPSod72"
            style={{ mixBlendMode: "multiply" }}
            d="M227.344,102.357C226.934,104.62,226.637,106.917,226.495,108.591C223.906,111.328,220.966,112.942,218.764,113.312C210.863,114.641,204.379,101.924,199.676,96.3164C206.321,103.736,211.901,108.685,216.726,109.303C220.651,109.804,224.712,106.573,227.344,102.357Z"
            opacity="0.5"
            clipRule="evenodd"
            fill="url(#eQEgujtPSod72-fill)"
            fillRule="evenodd"
            stroke="none"
            strokeWidth="1"
          ></path>
        </g>
        <path
          id="eQEgujtPSod73"
          style={{ mixBlendMode: "multiply" }}
          d="M249.625,104.306C243.662,87.1008,243.003,80.2769,235.826,82.3927L233.502,83.0761C235.22,85.9974,235.376,87.129,234.841,89.6147C233.482,95.9276,232.721,101.391,234.34,104.739C236.98,110.199,243.962,111.606,249.313,109.669L249.625,104.306Z"
          opacity="0.5"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod73-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod74"
          d="M231.815,67.9354C231.449,69.7127,229.771,77.1823,230.762,78.4361C231.266,79.063,233.012,78.8655,234.367,78.6805L238.196,71.6749L236.229,67.6L233.329,67.0703L231.815,67.9354Z"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod74-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod75"
          d="M231.813,67.9354C231.742,68.2771,231.623,68.8319,231.484,69.5027C232.081,70.0293,233.23,70.4023,234.648,70.3459C234.6,73.7782,233.321,75.8752,233.038,78.8279C233.485,78.7902,233.944,78.7307,234.365,78.6743L238.194,71.6749L236.227,67.6L233.327,67.0703L231.813,67.9354Z"
          clipRule="evenodd"
          fill="rgb(248,165,152)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod76"
          d="M239.377,62.8404C243.515,60.9597,245.649,63.0097,247.301,66.3135C249.039,69.8241,249.229,71.6139,250.414,72.9241C252.415,75.1465,255.03,74.692,260.37,75.0838C269.788,75.7734,270.275,85.5938,267.572,92.6057C264.358,100.918,255.149,106.498,247.853,107.601C238.831,108.962,236.103,104.207,235.868,98.4454C235.656,93.2358,239.604,88.7127,236.539,85.0108C234.949,83.0925,233.352,83.0518,233.406,79.5474C233.446,76.8862,235.628,73.5009,235.166,69.7175C234.606,69.7374,234.046,69.6634,233.505,69.4981C228.1,67.7679,230.262,58.5837,236.165,60.6055C237.394,61.0277,238.501,61.7981,239.377,62.8404Z"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod76-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod77"
          d="M259.788,102.4C256.039,105.221,251.669,107.029,247.829,107.609C238.807,108.97,236.079,104.215,235.844,98.4535C235.632,93.2439,239.58,88.7208,236.515,85.0189C234.924,83.1006,233.328,83.0599,233.382,79.5555C233.422,76.8943,235.604,73.509,235.142,69.7257C234.582,69.7455,234.022,69.6715,233.481,69.5062C231.056,68.7289,230.156,66.4532,230.43,64.3594C231.664,67.5691,233.668,68.406,236.894,68.359C237.573,73.2771,236.529,76.5808,237.766,79.4113C239.747,83.9313,242.183,81.7152,243.23,87.2476C244.32,93.0276,242.206,96.4724,244.478,100.87C247.147,106.036,255.328,103.716,259.788,102.4Z"
          transform="matrix(1 0 0 1 0 0.000001)"
          clipRule="evenodd"
          fill="rgb(36,9,61)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <g
          id="eQEgujtPSod78"
          style={{ mixBlendMode: "multiply", opacity: "0.35" }}
        >
          <g
            id="eQEgujtPSod79"
            style={{ mixBlendMode: "multiply", opacity: "0.35" }}
          >
            <path
              id="eQEgujtPSod80"
              d="M175.764,225.14C230.58,225.14,275.017,222.96,275.017,220.269C275.017,217.579,230.58,215.398,175.764,215.398C120.949,215.398,76.5117,217.579,76.5117,220.269C76.5117,222.96,120.949,225.14,175.764,225.14Z"
              fill="rgb(106,149,206)"
              stroke="none"
              strokeWidth="1"
            ></path>
          </g>
          <g
            id="eQEgujtPSod81"
            style={{ mixBlendMode: "multiply", opacity: "0.35" }}
          >
            <path
              id="eQEgujtPSod82"
              d="M175.764,222.208C220.002,222.208,255.852,221.34,255.852,220.264C255.852,219.189,219.99,218.324,175.764,218.324C131.537,218.324,95.6758,219.192,95.6758,220.264C95.6758,221.336,131.529,222.208,175.764,222.208Z"
              clipRule="evenodd"
              fill="rgb(106,149,206)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
          </g>
        </g>
        <g id="eQEgujtPSod83" transform="matrix(1 0 0 1 0 40.000002)">
          <path
            id="eQEgujtPSod84"
            style={{ mixBlendMode: "multiply" }}
            d="M201.461,123.102L181.575,123.102C179.311,123.102,177.449,124.982,177.449,127.28L177.449,154.061C177.449,156.349,179.314,158.236,181.575,158.236L205.322,158.236L205.18,149.61L201.461,123.102Z"
            opacity="0.5"
            clipRule="evenodd"
            fill="url(#eQEgujtPSod84-fill)"
            fillRule="evenodd"
            stroke="none"
            strokeWidth="1"
          ></path>
          <path
            id="eQEgujtPSod85"
            d="M213.392482,123.102L186.253518,123.102C184.044441,123.102,182.258,124.982,182.258,127.28L182.258,154.061C182.258,156.349,184.063399,158.236,186.253518,158.236L213.392482,158.236C215.582601,158.236,217.388,156.356,217.388,154.061L217.388,127.28C217.394691,124.982,215.601559,123.102,213.392482,123.102Z"
            clipRule="evenodd"
            fill="url(#eQEgujtPSod85-fill)"
            fillRule="evenodd"
            stroke="none"
            strokeWidth="1"
          ></path>
          <g id="eQEgujtPSod86" transform="matrix(1 0 0 1 0.410998 -0.005499)">
            <path
              id="eQEgujtPSod87"
              d="M201.964722,129.586L201.550348,126.254L197.273652,126.254L196.862602,129.586C195.607292,129.849,194.401839,130.311,193.291671,130.953L190.726761,128.965L187.704267,131.987L189.554548,134.372C188.751282,135.519,188.174039,136.807,187.851625,138.168L184.992,138.544L184.992,142.817L187.851625,143.18C188.172931,144.542,188.751282,145.83,189.554548,146.976L187.704267,149.365L190.726761,152.383L193.291671,150.399C194.401839,151.041,195.607292,151.502,196.862602,151.763L197.273652,155.095L201.550348,155.095L201.964722,151.763C203.218924,151.502,204.423269,151.041,205.532329,150.399L208.097239,152.383L211.119733,149.365L209.27056,146.976C210.073826,145.83,210.651069,144.542,210.972375,143.18L213.832,142.817L213.832,138.544L210.972375,138.181C210.651069,136.819,210.072718,135.531,209.27056,134.385L211.119733,131.999L208.097239,128.978L205.532329,130.965C204.423269,130.323,203.218924,129.862,201.964722,129.598L201.964722,129.586ZM199.415324,133.413C200.85123,133.413,202.253898,133.839,203.44827,134.636C204.641535,135.433,205.572215,136.567,206.12176,137.893C206.671304,139.219,206.81423,140.678,206.533918,142.085C206.254714,143.493,205.563352,144.786,204.548467,145.801C203.532475,146.815,202.239494,147.507,200.831287,147.787C199.42308,148.067,197.963906,147.923,196.637687,147.374C195.311468,146.824,194.178033,145.894,193.380307,144.701C192.582582,143.508,192.157128,142.105,192.157128,140.67C192.15602,139.717,192.344372,138.773,192.708888,137.892C193.073405,137.012,193.607438,136.211,194.282181,135.538C194.955816,134.864,195.755757,134.329,196.637687,133.965C197.518509,133.6,198.462485,133.413,199.415324,133.413Z"
              clipRule="evenodd"
              fill="rgb(255,255,255)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
          </g>
        </g>
        <path
          id="eQEgujtPSod88"
          d="M63.3636,85.7106C63.0806,87.5694,62.5883,89.3906,63.6042,91.8605L54.0898,91.9295C57.3019,88.6038,57.5084,86.6008,57.4858,83.4883L61.0431,84.2813L63.3636,85.7106Z"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod88-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod89"
          d="M66.0655,73.1611C67.5399,75.2925,68.5445,80.1479,68.0464,83.8529C67.8823,85.1067,67.7267,86.674,66.9484,87.1253C66.0994,87.6269,64.8061,87.4106,62.8421,87.1629C59.9895,86.8056,60.2952,86.0502,58.8236,83.132L56.3672,76.3865L61.4611,70.8008L66.0655,73.1611Z"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod89-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod90"
          d="M66.0676,73.1611C66.3133,73.5245,66.5275,73.9128,66.7072,74.3208C65.912,74.8506,65.4111,74.9854,63.8319,74.8161C63.7244,76.5589,62.9433,80.9284,61.0557,80.4081C60.7218,80.314,60.3369,79.8125,59.9747,79.5523C59.5332,79.2389,58.9333,79.3987,59.1936,80.336C59.904,82.8781,60.5265,83.3514,59.7596,85.1004C59.5162,84.5864,59.2446,83.9438,58.8314,83.132L56.375,76.3865L61.4689,70.8008L66.0676,73.1611Z"
          clipRule="evenodd"
          fill="rgb(248,165,152)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod91"
          d="M63.3258,74.1202C67.8538,74.7315,68.4934,71.5343,67.4463,69.1615C66.136,66.1962,62.1571,64.1995,59.5224,68.8887C57.5867,67.8293,56.8396,68.0456,55.9821,70.456C52.456,69.5595,51.1966,73.0514,52.0201,76.3426C52.7814,79.3486,54.8105,81.2763,56.4434,83.6147C56.9432,84.3148,57.3828,85.0651,57.7565,85.8559C58.8488,85.4797,59.095,84.9939,59.2705,84.1193C59.3922,83.5113,58.7752,81.4519,58.6507,80.104C58.5602,79.1041,59.163,78.3174,60.1223,78.9913C60.4053,79.1919,60.5836,79.684,61.0251,80.1291C63.1815,78.6998,63.0004,76.6435,63.3258,74.1202Z"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod91-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod92"
          d="M63.326,74.1256C67.854,74.7368,68.4935,71.5396,67.4465,69.1668C67.4295,69.1292,67.4125,69.0884,67.3927,69.0508C67.2314,71.1008,66.139,72.3075,64.2797,72.2386C62.1912,72.1602,61.5799,72.3389,61.2149,75.2383C61.0253,76.768,60.9007,77.7459,60.0404,77.4858C58.1783,76.9498,57.1397,77.8588,57.1256,80.357C57.1256,81.592,56.6982,82.5073,55.8945,82.8332C56.087,83.0871,56.2766,83.3473,56.4605,83.6106C56.9639,84.3392,57.278,85.2063,57.369,86.1182C60.5951,85.0055,58.9,82.617,58.6679,80.1062C58.5773,79.1063,59.1801,78.3195,60.1395,78.9935C60.4225,79.1941,60.6008,79.6862,61.0423,80.1313C63.1817,78.7051,63.0006,76.6488,63.326,74.1256Z"
          clipRule="evenodd"
          fill="rgb(36,9,61)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod93"
          d="M47.0984,92.7266C45.3721,94.4882,43.6119,96.1589,42.3893,97.9142C32.0826,112.684,39.732,126.316,63.4329,121.066C60.7841,102.694,57.7306,107.045,47.0984,92.7266Z"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod93-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <g
          id="eQEgujtPSod94"
          style={{ mixBlendMode: "multiply", opacity: "0.35" }}
        >
          <path
            id="eQEgujtPSod95"
            d="M37.9665,108.85C37.1176,118.476,45.8678,124.962,63.4362,121.075C61.4071,106.998,59.1403,106.261,53.4068,100.246L46.6149,103.616C46.0489,108.133,45.4829,112.468,45.0669,117.013C41.0314,115.126,38.9372,113.151,37.9665,108.85Z"
            clipRule="evenodd"
            fill="rgb(25,172,200)"
            fillRule="evenodd"
            stroke="none"
            strokeWidth="1"
          ></path>
        </g>
        <path
          id="eQEgujtPSod96"
          d="M30.7197,220.796L41.649,220.99C42.1951,220.32,42.3423,218.016,41.7678,217.025C40.9922,215.758,40.5271,214.289,40.4179,212.762L36.3088,212.972L34.5344,212.051C33.7392,213.204,32.0526,215.336,30.8555,217.213C30.281,218.154,30.4763,219.815,30.7197,220.796Z"
          clipRule="evenodd"
          fill="rgb(31,50,99)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <g
          id="eQEgujtPSod97"
          style={{ mixBlendMode: "multiply", opacity: "0.3" }}
        >
          <path
            id="eQEgujtPSod98"
            d="M40.8301,215.552C40.6058,214.64,40.4673,213.706,40.4169,212.762L36.3078,212.972L34.5334,212.051C34.2221,212.505,33.7694,213.11,33.2656,213.794C34.8702,215.69,39.783,216.749,40.8301,215.552Z"
            clipRule="evenodd"
            fill="rgb(30,36,83)"
            fillRule="evenodd"
            stroke="none"
            strokeWidth="1"
          ></path>
        </g>
        <path
          id="eQEgujtPSod99"
          d="M48.4188,133.472C47.417,136.836,46.0954,139.375,44.7144,146.255C43.2116,153.731,42.7843,160.78,41.6552,168.049C39.3877,182.902,36.4455,197.618,32.8398,212.142C35.0614,214.192,39.4167,214.195,41.0043,213.572C45.7558,201.601,48.6763,189.925,52.859,177.791C58.5897,161.163,64.8411,144.509,69.802,128.711L48.4188,133.472Z"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod99-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod100"
          style={{ mixBlendMode: "multiply" }}
          d="M57.5167,133.243C55.2697,140.766,42.6509,195.072,41.0039,213.572C45.7554,201.601,48.6759,189.925,52.8586,177.791C58.5893,161.163,64.8407,144.509,69.8016,128.711L57.5167,133.243Z"
          opacity="0.5"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod100-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod101"
          d="M62.2834,211.068C61.9467,212.921,60.9279,214.338,60.7666,215.698C60.4836,218.046,61.7089,220.4,64.2135,220.428L80.6046,220.588C79.7358,214.388,70.9827,217.826,68.0339,210.949L64.2191,211.187L62.2834,211.068Z"
          clipRule="evenodd"
          fill="rgb(31,50,99)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <g
          id="eQEgujtPSod102"
          style={{ mixBlendMode: "multiply", opacity: "0.3" }}
        >
          <path
            id="eQEgujtPSod103"
            d="M62.2882,211.068C62.1766,211.648,62.0107,212.213,61.793,212.755C63.3296,213.936,66.2926,214.733,69.7169,213.429C68.9998,212.744,68.4212,211.899,68.0189,210.949L64.2041,211.187L62.2882,211.068Z"
            clipRule="evenodd"
            fill="rgb(30,36,83)"
            fillRule="evenodd"
            stroke="none"
            strokeWidth="1"
          ></path>
        </g>
        <path
          id="eQEgujtPSod104"
          d="M73.5162,131.927C74.1869,136.375,74.4048,140.616,74.3482,146.148C74.1388,166.94,71.1193,190.483,69.11,211.252C66.4357,212.387,63.4953,212.327,61.2653,211.312C60.9427,199.288,60.7559,186.502,59.6409,174.666C57.7901,155.006,50.5058,141.233,54.7649,129.664L67.446,129.188L73.5162,131.927Z"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod104-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod105"
          d="M44.1455,97.049C40.3335,104.033,46.234,103.033,46.7972,107.998C47.8895,119.317,48.3989,127.071,46.5142,138.644C58.1,143.292,67.5776,141.562,73.9223,138.719C72.6573,129.83,74.0978,108.117,72.0461,99.8764C70.8518,95.0712,76.175,93.9208,72.8951,92.5103C66.9069,89.9337,58.4283,87.8085,52.2193,89.8647C50.2384,90.523,48.6083,91.2,47.0235,92.8425C45.9006,94.0977,44.9328,95.5122,44.1455,97.049Z"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod105-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <g
          id="eQEgujtPSod106"
          style={{ mixBlendMode: "multiply", opacity: "0.35" }}
        >
          <path
            id="eQEgujtPSod107"
            d="M62.5589,141.474C66.4622,141.266,70.3065,140.336,73.9325,138.722C72.6675,129.832,74.108,108.12,72.0563,99.8791C70.862,95.0738,75.8541,94.6914,72.5855,93.2966C70.7234,92.4973,66.5265,94.6852,65.553,97.1144C59.1177,113.179,59.6186,126.842,62.5589,141.474Z"
            clipRule="evenodd"
            fill="rgb(25,172,200)"
            fillRule="evenodd"
            stroke="none"
            strokeWidth="1"
          ></path>
        </g>
        <path
          id="eQEgujtPSod108"
          d="M87.7359,146.812L81.793,132.794C81.6638,132.501,81.4363,132.275,81.1588,132.164C80.8813,132.053,80.5758,132.067,80.3073,132.202L60.4693,142.58C60.2034,142.724,59.9987,142.976,59.8987,143.284C59.7988,143.592,59.8116,143.931,59.9344,144.229L65.8773,158.247C66.0065,158.54,66.2341,158.767,66.5115,158.877C66.789,158.988,67.0945,158.974,67.3631,158.839L87.2067,148.461C87.4716,148.317,87.6751,148.064,87.774,147.756C87.8728,147.448,87.8592,147.109,87.7359,146.812Z"
          clipRule="evenodd"
          fill="rgb(163,207,239)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <g
          id="eQEgujtPSod109"
          style={{ mixBlendMode: "multiply", opacity: "0.5" }}
        >
          <path
            id="eQEgujtPSod110"
            d="M72.6358,136.168L66.9023,139.168C68.3173,141.719,69.5851,144.054,70.6181,146.841C70.6011,148.869,71.1445,151.035,74.58,155.016L78.1967,153.135L75.8592,149.687L72.6358,136.168Z"
            clipRule="evenodd"
            fill="rgb(163,207,239)"
            fillRule="evenodd"
            stroke="none"
            strokeWidth="1"
          ></path>
        </g>
        <path
          id="eQEgujtPSod111"
          d="M79.1817,153.136C77.6082,154.01,76.7762,154.462,76.3743,154.333C75.3555,154.02,73.5444,150.945,72.7463,149.24C72.0304,147.729,73.1623,145.923,72.5794,144.892C73.4114,143.359,75.1263,141.099,76.5639,141.074C76.8979,144.854,81.14,148.763,81.7994,150.86C82.1956,152.136,79.9967,152.678,79.1817,153.136Z"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod111-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod112"
          d="M77.9462,153.815C77.1453,154.238,76.6557,154.442,76.3755,154.339C75.3567,154.025,73.5456,150.95,72.7475,149.245C72.0287,147.734,73.1636,145.929,72.5806,144.898C73.4126,143.365,72.5806,145.004,73.9956,144.979C73.8484,148.496,75.8803,150.637,77.9462,153.815Z"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod112-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <path
          id="eQEgujtPSod113"
          d="M64.1937,109.262C63.7013,114.459,63.5343,119.716,64.1343,123.681C65.1757,130.577,67.4,137.074,72.1289,145.66C75.0324,146.453,77.5483,144.299,77.2455,141.93C75.3636,137.598,73.2354,125.63,73.2156,122.681C73.1817,116.75,74.0873,111.259,75.7626,102.708C77.0814,96.0687,75.5418,93.3574,72.6949,92.3857C65.0964,89.806,64.7342,103.535,64.1937,109.262Z"
          clipRule="evenodd"
          fill="url(#eQEgujtPSod113-fill)"
          fillRule="evenodd"
          stroke="none"
          strokeWidth="1"
        ></path>
        <g id="eQEgujtPSod114" transform="matrix(1 0 0 1 15.737334 35.6265)">
          <path
            id="eQEgujtPSod115"
            d="M188.035882,9.94141C190.205493,9.94141,192.326374,10.5848,194.130507,11.7903C195.93464,12.9958,197.34007,14.7092,198.170702,16.7139C199.001334,18.7185,199.218406,20.9244,198.795337,23.0525C198.372269,25.1806,197.32678,27.1354,195.792879,28.6697C194.258978,30.204,192.304224,31.2489,190.176698,31.6722C188.048065,32.0955,185.843013,31.8782,183.838421,31.0479C181.833829,30.2175,180.120511,28.8114,178.915541,27.0072C177.709463,25.2031,177.066,23.082,177.066,20.9122C177.066,19.4715,177.35063,18.0449,177.901062,16.7139C178.452602,15.3828,179.261084,14.1734,180.278885,13.1547C181.297794,12.1359,182.507194,11.3278,183.838421,10.7765C185.169647,10.2252,186.59612,9.94141,188.035882,9.94141Z"
            clipRule="evenodd"
            fill="url(#eQEgujtPSod115-fill)"
            fillRule="evenodd"
            stroke="none"
            strokeWidth="1"
          ></path>
          <g id="eQEgujtPSod116" transform="matrix(1 0 0 1 1.066997 0.000001)">
            <path
              id="eQEgujtPSod117"
              d="M186.973,15.8086C187.463,15.8086,187.941,15.9694,188.349,16.2708C188.756,16.5722,189.073,17.0005,189.261,17.5017C189.448,18.0029,189.497,18.5543,189.401,19.0864C189.306,19.6184,189.07,20.1071,188.724,20.4907C188.378,20.8742,187.936,21.1355,187.456,21.2413C186.976,21.3471,186.478,21.2928,186.025,21.0852C185.573,20.8776,185.186,20.5261,184.914,20.0751C184.642,19.624,184.497,19.0937,184.497,18.5513C184.497,17.8239,184.758,17.1263,185.222,16.6119C185.686,16.0976,186.316,15.8086,186.973,15.8086ZM188.886,21.4037C189.415,21.5283,189.889,21.8498,190.23,22.3146C190.571,22.7794,190.758,23.3595,190.759,23.9583L190.759,23.9959C190.303,24.6216,189.726,25.1263,189.07,25.4729C188.415,25.8196,187.698,25.9996,186.971,25.9996C186.245,25.9996,185.528,25.8196,184.873,25.4729C184.217,25.1263,183.64,24.6216,183.184,23.9959L183.184,23.9583C183.186,23.3597,183.373,22.7799,183.714,22.3152C184.054,21.8505,184.528,21.5289,185.057,21.4037C185.587,21.9169,186.267,22.1997,186.971,22.1997C187.676,22.1997,188.356,21.9169,188.886,21.4037Z"
              clipRule="evenodd"
              fill="rgb(255,255,255)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eQEgujtPSod118"
              d="M182.159,17.3477C182.373,17.3477,182.582,17.4179,182.76,17.5494C182.938,17.681,183.076,17.868,183.158,18.0868C183.24,18.3056,183.261,18.5464,183.22,18.7786C183.178,19.0109,183.075,19.2243,182.924,19.3917C182.773,19.5592,182.58,19.6732,182.37,19.7194C182.161,19.7656,181.943,19.7419,181.746,19.6513C181.548,19.5606,181.379,19.4072,181.261,19.2103C181.142,19.0134,181.078,18.7819,181.078,18.545C181.078,18.2275,181.192,17.9229,181.395,17.6984C181.598,17.4738,181.873,17.3477,182.159,17.3477ZM182.994,19.7894C183.225,19.8444,183.432,19.985,183.581,20.1879C183.729,20.3909,183.811,20.644,183.812,20.9053L183.812,20.921C183.613,21.194,183.361,21.4141,183.074,21.5654C182.788,21.7166,182.475,21.7951,182.158,21.7951C181.841,21.7951,181.528,21.7166,181.242,21.5654C180.955,21.4141,180.703,21.194,180.504,20.921L180.504,20.9053C180.505,20.644,180.587,20.3909,180.736,20.1879C180.884,19.985,181.091,19.8444,181.322,19.7894C181.553,20.0136,181.851,20.1372,182.158,20.1372C182.466,20.1372,182.763,20.0136,182.994,19.7894Z"
              clipRule="evenodd"
              fill="rgb(255,255,255)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
            <path
              id="eQEgujtPSod119"
              d="M191.782,17.3477C191.995,17.3477,192.204,17.4179,192.382,17.5494C192.56,17.681,192.699,17.868,192.78,18.0868C192.862,18.3056,192.884,18.5464,192.842,18.7786C192.8,19.0109,192.697,19.2243,192.546,19.3917C192.395,19.5592,192.202,19.6732,191.993,19.7194C191.783,19.7656,191.565,19.7419,191.368,19.6513C191.17,19.5607,191.002,19.4072,190.883,19.2103C190.764,19.0134,190.701,18.7819,190.701,18.545C190.701,18.2275,190.814,17.9229,191.017,17.6984C191.22,17.4738,191.495,17.3477,191.782,17.3477ZM192.616,19.7894C192.847,19.8439,193.054,19.9843,193.203,20.1874C193.352,20.3904,193.434,20.6438,193.434,20.9053L193.434,20.921C193.235,21.1939,192.983,21.4141,192.697,21.5653C192.411,21.7165,192.098,21.795,191.782,21.795C191.465,21.795,191.152,21.7165,190.866,21.5653C190.58,21.4141,190.328,21.1939,190.129,20.921L190.129,20.9053C190.13,20.6438,190.211,20.3904,190.36,20.1874C190.509,19.9843,190.716,19.8439,190.947,19.7894C191.178,20.0134,191.475,20.1369,191.782,20.1369C192.089,20.1369,192.385,20.0134,192.616,19.7894Z"
              clipRule="evenodd"
              fill="rgb(255,255,255)"
              fillRule="evenodd"
              stroke="none"
              strokeWidth="1"
            ></path>
          </g>
        </g>
        <g id="eQEgujtPSod120" transform="matrix(1 0 0 1 -12.424376 17.599188)">
          <path
            id="eQEgujtPSod121"
            d="M107.407106,10.832C109.576772,10.832,111.697706,11.4755,113.501885,12.6809C115.306063,13.8864,116.712636,15.5998,117.542182,17.6045C118.372835,19.6091,118.589912,21.815,118.166833,23.9431C117.743753,26.0713,116.698238,28.0261,115.164298,29.5603C113.630359,31.0946,111.675555,32.1395,109.547976,32.5628C107.419288,32.9861,105.214181,32.7689,103.209538,31.9385C101.204895,31.1082,99.491646,29.702,98.286312,27.8979C97.080869,26.0937,96.4375,23.9726,96.4375,21.8028C96.4375,18.8932,97.593326,16.1027,99.650577,14.0453C101.707717,11.9879,104.497604,10.832,107.407106,10.832Z"
            clipRule="evenodd"
            fill="url(#eQEgujtPSod121-fill)"
            fillRule="evenodd"
            stroke="none"
            strokeWidth="1"
          ></path>
          <path
            id="eQEgujtPSod122"
            d="M110.24,20.8046L110.24,17.4852C110.24,16.8681,110.019,16.2762,109.625,15.8395C109.231,15.4028,108.697,15.1571,108.14,15.1562L104.552,15.1562C103.994,15.1571,103.46,15.4027,103.066,15.8393C102.672,16.2759,102.45,16.8678,102.449,17.4852L102.449,20.8046C102.033,21.5688,101.809,22.4416,101.797,23.3337C101.786,24.2257,101.989,25.1051,102.385,25.8819C102.781,26.6586,103.357,27.3049,104.052,27.7545C104.748,28.2042,105.539,28.4412,106.345,28.4412C107.15,28.4412,107.941,28.2042,108.637,27.7545C109.332,27.3049,109.908,26.6586,110.304,25.8819C110.7,25.1051,110.903,24.2257,110.892,23.3337C110.881,22.4416,110.656,21.5688,110.24,20.8046ZM106.915,24.1116L106.915,25.9766C106.915,26.1429,106.855,26.3023,106.749,26.4199C106.643,26.5374,106.499,26.6035,106.349,26.6035C106.199,26.6035,106.055,26.5374,105.949,26.4199C105.842,26.3023,105.783,26.1429,105.783,25.9766L105.783,24.1116C105.633,23.9811,105.523,23.8021,105.469,23.5995C105.415,23.3968,105.42,23.1806,105.482,22.9809C105.544,22.7812,105.661,22.608,105.817,22.4855C105.972,22.3629,106.158,22.297,106.349,22.297C106.54,22.297,106.726,22.3629,106.881,22.4855C107.036,22.608,107.153,22.7812,107.215,22.9809C107.278,23.1806,107.282,23.3968,107.228,23.5995C107.175,23.8021,107.065,23.9811,106.915,24.1116ZM108.432,18.9302C107.787,18.5616,107.072,18.3692,106.346,18.3692C105.62,18.3692,104.905,18.5616,104.26,18.9302L104.26,17.4852C104.26,17.4427,104.267,17.4005,104.282,17.3611C104.296,17.3218,104.318,17.2861,104.345,17.2564C104.372,17.2254,104.404,17.2008,104.439,17.1841C104.475,17.1674,104.513,17.1589,104.552,17.1592L108.14,17.1592C108.179,17.1589,108.217,17.1674,108.253,17.1841C108.288,17.2008,108.32,17.2254,108.347,17.2564C108.401,17.3175,108.431,17.3996,108.432,17.4852L108.432,18.9302Z"
            transform="matrix(1.183737 0 0 1 -18.476397 -0.0037)"
            clipRule="evenodd"
            fill="rgb(255,255,255)"
            fillRule="evenodd"
            stroke="none"
            strokeWidth="1"
          ></path>
        </g>
      </svg>
    </div>
  );
};
